import { render, staticRenderFns } from "./AvailableVoucherTemplate.vue?vue&type=template&id=356adad6"
import script from "./AvailableVoucherTemplate.vue?vue&type=script&lang=js"
export * from "./AvailableVoucherTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports